module.exports = {
        srcSet: __webpack_public_path__ + "static/media/section3-500.ac73bc71.webp"+" 500w",
        images: [{path: __webpack_public_path__ + "static/media/section3-500.ac73bc71.webp",width: 500,height: 500}],
        src: __webpack_public_path__ + "static/media/section3-500.ac73bc71.webp",
        toString: function(){return __webpack_public_path__ + "static/media/section3-500.ac73bc71.webp"},
        
        width: 500,
        height: 500
      }